import { Box, Typography } from "@mui/material";

type Props = {
  id: number;
  // e.g. a region tag, rendered as "EU-4" instead of a bare id.
  prefix?: string;
};

export default function IdBadge({ id, prefix }: Props) {
  return (
    <Box
      sx={(theme) => ({
        backgroundColor: theme.palette.primary.main,
        borderRadius: "6px",
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        height: 25,
        ...(prefix ? { padding: "2px 6px" } : { padding: "2px", width: 25 }),
      })}
    >
      <Typography
        variant="body2"
        sx={{ color: "white", fontWeight: 700, whiteSpace: "nowrap" }}
      >
        {prefix ? `${prefix}-${id}` : id}
      </Typography>
    </Box>
  );
}
